// react-footer.directive.js
import React from 'react';
import angular from 'angular';
import ReactDOM from 'react-dom';
import Footer from '../components/Footer.component';

angular.module('core').directive('reactFooter', reactFooterDirective);

/* @ngInject */
function reactFooterDirective() {
  return {
    restrict: 'E',
    template: '<div id="react-footer"></div>',
    link() {
      ReactDOM.render(
        React.createElement(Footer),
        document.getElementById('react-footer'),
      );
    },
  };
}
